import React from 'react';

import Avatar from '@atlaskit/avatar';

import { Filter, TestCaseInCycle } from '@qality/common-model';

import {
  ALL_ASSIGNEES,
  AssigneeOption,
  AssigneeOptions,
  UNASSGINED,
} from './TestCaseInCycleAssigneeFilter';
import { OptionWrapperStyled } from './TestCaseInCycleAssigneeFilter.styled';

export const filterOutTestCasesWithoutPermission: Filter<TestCaseInCycle> = (
  testCase
) => {
  return Boolean(testCase.testCase);
};

export const mapToAssigneeOption = (
  testCase: TestCaseInCycle
): AssigneeOption => {
  const {
    displayName = UNASSGINED.label,
    accountId = UNASSGINED.value,
    avatarUrls,
  } = testCase.testExecution?.executionAssignee ?? {};

  return {
    label: displayName,
    value: accountId,
    avatarUrl: avatarUrls?.['16x16'],
  };
};

export const dedupeAssigneeOptions = (
  uniqueAssigneeOptions: AssigneeOptions,
  assigneeOption: AssigneeOption
): AssigneeOptions => {
  const isDuplicate =
    uniqueAssigneeOptions.find((uniqueAssigneeOption) => {
      return uniqueAssigneeOption.value === assigneeOption.value;
    }) !== undefined;

  return isDuplicate
    ? uniqueAssigneeOptions
    : [...uniqueAssigneeOptions, assigneeOption];
};

export const handleAllAssigneesOption = (
  assigneeOptions: AssigneeOptions
): AssigneeOptions => {
  const isNoAssigneeOptionSelected = assigneeOptions.length === 0;

  return isNoAssigneeOptionSelected ? [ALL_ASSIGNEES] : assigneeOptions;
};

export const filterOutAllAssignees: Filter<AssigneeOption> = (
  assigneeOption
) => {
  return assigneeOption.value !== ALL_ASSIGNEES.value;
};

export const formatOptionLabel = (option: AssigneeOption): JSX.Element => {
  return (
    <OptionWrapperStyled>
      <Avatar
        size='xsmall'
        src={option.avatarUrl}
        borderColor='var(--ds-soldevelo-aureola-border, var( --ds-fb-soldevelo-aureola-border))'
      />
      {option.label}
    </OptionWrapperStyled>
  );
};
